/* ================================================================
 * Copyright © 2025 Tobeunicorn Co., Ltd. All rights reserved.
 *
 * 프로젝트명 : ArmyLink V1.0
 * 설명 : 다이얼로그 홍보결과목록 > 관심표명자 생일 컴포넌트
 * 버전 : 1.0
 * 파일명 : DialogInterestBirthday.tsx
 * 작성자 : 강동형
 * 작성일 : 2025-07-17
 * ================================================================ 

 *================================================================
 */

import styled from 'styled-components'
import { NextButton, NextButtonWrapper } from '../common/CommonStyled'
import { useState } from 'react'
import { useInterestedFilterStore } from 'src/stores/InterestedStore'
import { LoadInterestedData } from './useSubmitInterestedFilter'
import DateRangePickerCouncelDate from './DateRangePickerCouncelDate'

const PageWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-bottom: 80px;
    
    padding: 20px 24px;
`

const TitleWrapper = styled.span`
    font-size:16px;
    font-weight:500;
`

const DialogCouncelday = () => {
    const setField = useInterestedFilterStore((state)=>state.setField)
    const [resetTrigger,setResetTrigger] = useState(0)
    const temp_start_date = useInterestedFilterStore((state)=>state.temp_start_date)
    const temp_end_date = useInterestedFilterStore((state)=>state.temp_end_date)
    const handleSubmit = async () => {
        await setField('start_date',temp_start_date)
        await setField('end_date',temp_end_date)
        LoadInterestedData()
    }
    const onClickReset = ()=>{
        setResetTrigger((prev)=>prev+1)
    }
  return (
    <PageWrapper>
        <TitleWrapper>
            상담일
        </TitleWrapper>
        <DateRangePickerCouncelDate resetTrigger={resetTrigger}/>
        <NextButtonWrapper $isBorder={false}>
            <NextButton style={{background:'#F5F5F5', color:'#7F7F89', minWidth:'90px', width:'90px', boxShadow:'none', border:'1px solid #00001480'}} onClick={onClickReset}>초기화</NextButton>
            <NextButton onClick={handleSubmit} style={{margin:'5px',padding:'10px', height:'46px', boxShadow:'none'}}>적용</NextButton>
        </NextButtonWrapper>
    </PageWrapper>
)
}

export default DialogCouncelday